
<modal
  disable-close-backdrop
  title="Watchlist Alerts"
  :open="open"
  @close="closeModal"
>
  <div class="description">
    <div>{{ card.label }}</div>
    <div>Value: {{ $filters.currency(card.currentValue, { full: true }) }}</div>
  </div>

  <br />

  <form @submit.stop.prevent="submit">
    <currency-input
      id="alertBelowPrice"
      v-model="alertBelowPrice"
      label="Alert me when it drops below this price"
    >
      <icon-button icon="close" @click="clearBelow" />
    </currency-input>

    <currency-input
      id="alertAbovePrice"
      v-model="alertAbovePrice"
      label="Alert me when it goes above this price"
    >
      <icon-button icon="close" @click="clearAbove" />
    </currency-input>

    <div class="button-row">
      <btn
        type="submit"
        loading-text="Submitting"
        :loading="submitting"
      >
        Submit
      </btn>

      <btn kind="secondary" @click="closeModal">
        Cancel
      </btn>
    </div>
  </form>
</modal>
